import React from "react";
import { Box, Chip } from "@mui/material";
import M3Tooltip from "../common/M3Tooltip";

interface LabelProps {
  color?: string;
  name?: string;
  labelCompleteMode: boolean;
}

export const Label: React.FC<LabelProps> = ({
  color,
  labelCompleteMode,
  name,
}) => {
  if(!labelCompleteMode) {
    return <M3Tooltip title={name}>
      <Box sx={{ height: 5, borderRadius: 1, backgroundColor: color, width: 25 }}></Box>
    </M3Tooltip>
  }
  return (
    <Chip
      sx={{
        "& .MuiChip-label": {
          px: 1,
          py: 1,
        },
        fontSize: 13,
        height: 21,
        fontWeight: 500,
        borderRadius: 1,
        backgroundColor: "transparent",
        borderColor: color,
        borderWidth: 2,
        borderStyle: "solid",
        color: color,
        marginRight: "0.8em",
      }}
      label={name}
    />
  );
};
